import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g fill="#3E414A" fillRule="nonzero">
          <circle cx="13.171" cy="13.171" r="1.447" />
          <path d="M11.724 15.342h2.895v7.961h-2.895zM21.393 15.342c-2.172 0-2.432 1.289-2.432 1.289v-1.289h-2.895v7.961h2.895v-4.342s0-1.447 1.23-1.447c.724 0 .941.644.941 1.447v4.342h2.895v-4.342c0-2.265-.984-3.619-2.634-3.619z" />
          <path d="M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-.973c9.404 0 17.027-7.623 17.027-17.027S27.404.973 18 .973.973 8.596.973 18 8.596 35.027 18 35.027z" />
        </g>
      </svg>
    )
  }
}

export default SvgFile
